import { JetView } from 'webix-jet';
import {
    devConfig, // Development configuration settings
    countries, // List of countries
    profile, // User profile information
    cashDesks, // Cash desk information
    agentList, // List of agents
} from 'config/config';

/**
 * FilterBetShopView class extends JetView to create a filter form for betting shops.
 */
export default class FilterBetShopView extends JetView {
    /**
     * Configures the UI components of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Filter form layout
        const filter = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for competition selection
                            name: 'Competition',
                            label: _('Competidor'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 1, value: _('Intralot') },
                                { id: 2, value: _('BetCris') },
                                { id: 3, value: _('Apuesta Total') },
                            ],
                        },
                        {
                            view: 'text', // Input for name
                            name: 'Name',
                            label: "<span class='icon-user'></span>" + _('Nombre'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                            invalidMessage: _('Nombre'),
                        },
                        {
                            view: 'text', // Input for description
                            name: 'Description',
                            labelPosition: 'top',
                            label: _('Descripción'),
                            placeholder: _('Descripción'),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountryId',
                            id: 'Fcountry',
                            localId: 'FCountry:combo',
                            labelPosition: 'top',
                            label: "<span class='icon-language'></span>" + _('País'),
                            placeholder: _('Click para seleccionar '),
                            options: [],
                        },
                        {
                            view: 'richselect', // Dropdown for region selection
                            name: 'RegionId',
                            id: 'FProvinceRegion',
                            localId: 'FProvinceRegion:combo',
                            labelPosition: 'top',
                            label: _('Provincia/Región'),
                            placeholder: _('Click para seleccionar '),
                            options: [],
                        },
                        {
                            view: 'richselect', // Dropdown for city selection
                            name: 'CityId',
                            id: 'FCity',
                            localId: 'FCity:combo',
                            labelPosition: 'top',
                            label: "<span class='icon-language'></span>" + _('Ciudad'),
                            placeholder: _('Click para seleccionar '),
                            options: [],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for latitude
                            name: 'Latitud',
                            label: _('Latitud'),
                            placeholder: _('Latitud'),
                            labelPosition: 'top',
                        },
                        {
                            view: 'text', // Input for longitude
                            name: 'Longitud',
                            label: _('Longitud'),
                            placeholder: _('Longitud'),
                            labelPosition: 'top',
                        },
                        {
                            view: 'text', // Input for address
                            name: 'Address',
                            label: _('Dirección'),
                            placeholder: _('Dirección'),
                            labelPosition: 'top',
                        },
                    ],
                },
            ],
        };

        // Upper section containing the filter form
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 250 : 0,
            cols: [filter],
        };

        // Button section for actions
        const buttons = {
            margin: 2,
            cols: [
                {},
                {
                    view: 'button', // Button to add a new betting point
                    value: _('Añadir Punto'),
                    type: 'form',
                    width: 130,
                    hidden: !devConfig.getPermAction('betShopCompetence', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-betShopCompetence',
                    click: () => {
                        this.app.callEvent('addBetShop:button', [[]]); // Trigger add event
                    },
                },
                {
                    view: 'button', // Button to consult/filter
                    value: _('Consultar'),
                    type: 'form',
                    width: 90,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter values
                        this.app.callEvent('betShop:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };

        // Accordion section to hold filters
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the filter section
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Return the complete form configuration
        return {
            id: 'filter',
            view: 'form',
            type: 'clean',
            rows: [accordion_section],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element if screen width is less than 500
            }
        });

        // AJAX request to fetch agent countries
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Show error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize JSON keys
                            .replace(/"Name"/g, '"value"'),
                    );
                    var optionsProvinceRegions = $$('Fcountry').getList();
                    optionsProvinceRegions.clearAll(); // Clear existing options
                    optionsProvinceRegions.parse(data.Data); // Populate with new data
                },
            });

        // Event handler for country selection change
        $$('Fcountry').attachEvent('onChange', function (newv, oldv) {
            var optionscountries = this.getList().getItem(newv);
            var optionsProvinceRegions = $$('FProvinceRegion').getList();
            optionsProvinceRegions.clearAll(); // Clear existing region options
            optionsProvinceRegions.parse(optionscountries.departments); // Populate regions based on selected country
            $$('FProvinceRegion').setValue(''); // Reset region selection
            $$('FCity').setValue(''); // Reset city selection
        });

        // Event handler for region selection change
        $$('FProvinceRegion').attachEvent('onChange', function (newv, oldv) {
            var optionsProvinceRegions = this.getList().getItem(newv);
            var optionsCity = $$('FCity').getList();
            if ($$('FProvinceRegion').getValue() != '') {
                optionsCity.clearAll(); // Clear existing city options
                optionsCity.parse(optionsProvinceRegions.cities); // Populate cities based on selected region
                $$('FCity').setValue(''); // Reset city selection
            }
        });
    }
}

// FILE DOCUMENTED
